import { useState } from 'react';
/**
 * Determines when one or many elements take focus.
 *
 * @returns {{ focus: boolean, focusProps: Object }}
 */

export function useFocus() {
  var _useState = useState(false),
      focus = _useState[0],
      setFocus = _useState[1];

  return {
    focus: focus,
    focusProps: {
      onFocus: function onFocus() {
        return setFocus(true);
      },
      onBlur: function onBlur() {
        return setFocus(false);
      }
    }
  };
}